






































import Vue from 'vue';
import Component from 'vue-class-component';
import { get } from '@/utilities/helpers';

@Component({
	inheritAttrs: false,
	model: {
		prop: 'checked',
		event: 'change',
	},
	props: {
		checked: { type: [Object, Number, Boolean, String] },
		description: String,
		label: String,
		tooltip: { type: [Boolean, String], default: false },
	},
})
class NpRadio extends Vue {
	public checked!: any;
	public description!: string;
	public label!: string;
	public tooltip!: boolean|string;

	public get selected(): boolean {
		return this.checked === this.$attrs.value;
	}

	public updateValue() {
		this.$nextTick(() => {
			if (get('radio.checked', this.$refs)) {
				this.$emit('change', this.$attrs.value);
			}
		});
	}
}

export default NpRadio;
